<template>
  <div v-if="isOpen" class="chat-widget" role="region" aria-label="Widget de chat">
    <div class="chat-header">
      <div class="chat-header-left">
        <div class="bot-avatar" aria-hidden="true">
          <span class="bot-avatar-initial">SiDIA</span>
        </div>
        <div class="chat-header-text">
          <div class="chat-bot-name">Assistente</div>
          <div class="chat-bot-status">
            <span class="status-dot" aria-hidden="true"></span>
            Estamos Online
          </div>
        </div>
      </div>

      <button type="button" class="chat-close-btn" @click="isOpen = false" aria-label="Fechar">
        X
      </button>
    </div>

    <div class="chat-body">
      <div ref="chatWindow" class="chat-window">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="message-row"
          :class="message.role === 'user' ? 'message-row-user' : 'message-row-ai'"
        >
          <div v-if="message.role !== 'user'" class="row-avatar" aria-hidden="true">
            <div class="row-avatar-bot">
              <span class="bot-avatar-initial">SiDIA</span>
            </div>
          </div>

          <div
            class="message-bubble"
            :class="message.role === 'user' ? 'bubble-user' : 'bubble-ai'"
          >
            <span v-if="message.role === 'ai' && message.text === ''" class="typing-indicator">
              Digitando...
            </span>
            <span v-else>{{ message.text }}</span>
          </div>

          <div v-if="message.role === 'user'" class="row-avatar user-avatar" aria-hidden="true"></div>
        </div>
      </div>

      <form class="chat-input-area" @submit.prevent="enviarMensagem">
        <input
          v-model="inputText"
          type="text"
          class="chat-input"
          placeholder="Digite sua pergunta..."
          :disabled="isWaiting"
        >
        <button
          type="submit"
          class="chat-send-btn"
          :disabled="isWaiting || inputText.trim() === ''"
        >
          {{ isWaiting ? 'Enviando...' : 'Enviar' }}
        </button>
      </form>
    </div>
  </div>

  <button v-else type="button" class="chat-open-btn" @click="isOpen = true">
    SiD IA
  </button>
</template>

<script>
import { http } from '@/helpers/easyindustriaapi/config';

export default {
  name: 'ChatEasySaude',
  data() {
    return {
      isOpen: false,
      inputText: '',
      isWaiting: false,
      messages: [],
      channelName: null,
      pusherChannel: null,
    };
  },
  computed: {
    userId() {
      const autheasy = this.$store.state.autheasy;
      const storeUser = autheasy && autheasy.user ? autheasy.user : null;
      if (storeUser && storeUser.id) {
        return Number(storeUser.id);
      }

      const localUser = JSON.parse(localStorage.getItem('user') || '{}');
      return Number(localUser.id || 0);
    },
    empresaContextoId() {
      const ce = this.$store.state.autheasy && this.$store.state.autheasy.currentEmpresa;
      if (ce && ce.id) {
        return Number(ce.id);
      }
      try {
        const raw = localStorage.getItem('currentEmpresa');
        if (!raw) return 0;
        const e = JSON.parse(raw);
        return e && e.id ? Number(e.id) : 0;
      } catch (err) {
        return 0;
      }
    },
  },
  watch: {
    userId(newId, oldId) {
      if (newId > 0 && newId !== oldId) {
        this.$nextTick(() => {
          this.conectarWebSocket();
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.conectarWebSocket();
      // Mensagem inicial estilo widget
      if (!this.messages.length) {
        this.messages.push({
          role: 'ai',
          text: 'Olá! Como posso ajudá-lo hoje?',
        });
      }
      this.rolarParaFinal();
    });
  },
  beforeDestroy() {
    this.desconectarWebSocket();
  },
  methods: {
    desconectarWebSocket() {
      if (this.pusherChannel) {
        try {
          this.pusherChannel.unbind('AiTokenReceived');
        } catch (e) {
          /* noop */
        }
        this.pusherChannel = null;
      }
      if (window.pusher && this.channelName) {
        try {
          window.pusher.unsubscribe(this.channelName);
        } catch (e) {
          /* noop */
        }
      }
      this.channelName = null;
    },
    extrairChunkDoPayload(payload) {
      if (payload == null) {
        return '';
      }
      if (typeof payload === 'string') {
        try {
          return this.extrairChunkDoPayload(JSON.parse(payload));
        } catch (e) {
          return '';
        }
      }
      if (payload.chunk != null) {
        return String(payload.chunk);
      }
      if (payload.data && payload.data.chunk != null) {
        return String(payload.data.chunk);
      }
      return '';
    },
    async enviarMensagem() {
      const texto = this.inputText.trim();
      if (!texto || this.isWaiting) {
        return;
      }

      this.messages.push({ role: 'user', text: texto });
      this.messages.push({ role: 'ai', text: '' });
      this.inputText = '';
      this.isWaiting = true;
      this.rolarParaFinal();

      let payloadResposta = null;
      const payloadChat = { mensagem: texto };
      if (this.empresaContextoId > 0) {
        payloadChat.empresa_id = this.empresaContextoId;
      }

      try {
        const res = await http.post('ai/chat', payloadChat);
        payloadResposta = res.data;
      } catch (error) {
        const status = error && error.response ? error.response.status : null;
        if (status === 404) {
          try {
            const res = await http.post('ai/chat/stream', payloadChat);
            payloadResposta = res.data;
          } catch (fallbackError) {
            this.definirErroNaUltimaMensagemIa();
          }
        } else {
          this.definirErroNaUltimaMensagemIa();
        }
      } finally {
        this.isWaiting = false;
        this.rolarParaFinal();
        if (payloadResposta) {
          if (this.deveAtrasarFallbackReplyHttp()) {
            setTimeout(() => {
              this.aplicarReplySeAindaVazio(payloadResposta);
            }, 150);
          } else {
            this.$nextTick(() => {
              this.aplicarReplySeAindaVazio(payloadResposta);
            });
          }
        }
      }
    },
    conectarWebSocket() {
      this.desconectarWebSocket();

      if (!window.pusher || !this.userId) {
        return;
      }

      // Canal privado Laravel: PrivateChannel('chat.user.{id}') => nome Pusher "private-chat.user.{id}"
      this.channelName = `private-chat.user.${this.userId}`;
      const channel = window.pusher.subscribe(this.channelName);
      this.pusherChannel = channel;

      const onToken = (payload) => {
        const chunk = this.extrairChunkDoPayload(payload);
        if (!chunk) {
          return;
        }

        let lastIndex = this.messages.length - 1;

        if (lastIndex < 0 || this.messages[lastIndex].role !== 'ai') {
          this.messages.push({ role: 'ai', text: '' });
          lastIndex = this.messages.length - 1;
        }

        const current = this.messages[lastIndex];

        this.$set(this.messages, lastIndex, {
          role: current.role,
          text: `${current.text}${chunk}`,
        });

        this.rolarParaFinal();
      };

      channel.bind('AiTokenReceived', onToken);
    },
    rolarParaFinal() {
      this.$nextTick(() => {
        const chatWindow = this.$refs.chatWindow;
        if (!chatWindow) {
          return;
        }

        chatWindow.scrollTop = chatWindow.scrollHeight;
      });
    },
    definirErroNaUltimaMensagemIa() {
      const lastIndex = this.messages.length - 1;
      if (
        lastIndex >= 0 &&
        this.messages[lastIndex].role === 'ai' &&
        this.messages[lastIndex].text === ''
      ) {
        this.$set(this.messages, lastIndex, {
          role: 'ai',
          text: 'Nao foi possivel processar sua solicitacao no momento.',
        });
      }
    },
    deveAtrasarFallbackReplyHttp() {
      const p = window.pusher;
      if (!p || !p.connection) {
        return false;
      }
      const s = String(p.connection.state || '');
      return s === 'connecting' || s === 'connected';
    },
    aplicarReplySeAindaVazio(data) {
      const reply = data && data.reply;
      const lastIndex = this.messages.length - 1;
      if (lastIndex < 0 || this.messages[lastIndex].role !== 'ai') {
        return;
      }
      if (this.messages[lastIndex].text) {
        return;
      }
      if (reply != null && String(reply).trim() !== '') {
        this.$set(this.messages, lastIndex, {
          role: 'ai',
          text: String(reply),
        });
        this.rolarParaFinal();
        return;
      }
      if (data && data.success) {
        this.$set(this.messages, lastIndex, {
          role: 'ai',
          text: 'A IA nao retornou texto. Verifique OPENAI_API_KEY e o modelo no servidor.',
        });
        this.rolarParaFinal();
      }
    },
  },
};
</script>

<style scoped>
.chat-widget {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 380px;
  max-width: calc(100vw - 32px);
  height: 560px;
  max-height: calc(100vh - 64px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  border: 1px solid #eef2f7;
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 12px;
  background: linear-gradient(135deg, #20b486, #17a2b8);
  color: #fff;
}

.chat-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bot-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}

.row-avatar-bot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e8f7f3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bot-avatar-initial {
  font-weight: 800;
  color: #0f766e;
}

.chat-header-text {
  display: flex;
  flex-direction: column;
}

.chat-bot-name {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
}

.chat-bot-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  opacity: 0.95;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #b7ff52;
  box-shadow: 0 0 0 6px rgba(183, 255, 82, 0.2);
}

.chat-close-btn {
  border: 0;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-window {
  flex: 1;
  overflow-y: auto;
  padding: 14px 14px 6px;
  background: #f6f8fb;
}

.message-row {
  display: flex;
  margin-bottom: 10px;
  gap: 8px;
}

.message-row-ai {
  justify-content: flex-start;
}

.message-row-user {
  justify-content: flex-end;
}

.row-avatar {
  width: 34px;
  min-width: 34px;
  display: flex;
  align-items: flex-end;
}

.user-avatar {
  width: 0;
  min-width: 0;
}

.message-bubble {
  max-width: 78%;
  padding: 10px 14px;
  border-radius: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.4;
}

.bubble-ai {
  background: #ffffff;
  color: #111827;
  border-bottom-left-radius: 6px;
  border: 1px solid #e9eef6;
}

.bubble-user {
  background: #0ea5a4;
  color: #ffffff;
  border-bottom-right-radius: 6px;
}

.typing-indicator {
  opacity: 0.8;
  font-style: italic;
}

.chat-input-area {
  display: flex;
  gap: 10px;
  border-top: 1px solid #e9eef6;
  padding: 12px;
  background: #ffffff;
}

.chat-input {
  flex: 1;
  border: 1px solid #dbe3ee;
  background: #f7f9fc;
  border-radius: 999px;
  padding: 10px 14px;
  font-size: 14px;
  outline: none;
}

.chat-input:disabled {
  opacity: 0.75;
}

.chat-send-btn {
  border: 0;
  border-radius: 999px;
  padding: 0 16px;
  background: #0ea5a4;
  color: #fff;
  font-weight: 700;
  height: 40px;
  cursor: pointer;
}

.chat-send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.chat-open-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  border: 0;
  border-radius: 999px;
  background: #0ea5a4;
  color: #fff;
  font-weight: 800;
  padding: 12px 18px;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.15);
}

@media (max-width: 480px) {
  .chat-widget {
    width: calc(100vw - 24px);
    right: 12px;
    bottom: 12px;
    height: calc(100vh - 72px);
    max-height: none;
  }
}
</style>
